import React from "react";

const Support = () => {
  return (
    <div className="mt-5 flex h-full w-full flex-col gap-5">
      <div className="flex h-full w-full flex-col rounded-[20px] bg-white bg-clip-border p-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none">
        <h4 className="px-2 text-xl font-bold text-navy-700 dark:text-white">
          Support
        </h4>
        <div className="mt-4 px-2 text-gray-600 dark:text-gray-300">
          {/* Add your support content here */}
          <p>+91 8089 543 004</p>
        </div>
      </div>
    </div>
  );
};

export default Support;